import {
  PatientActionReturnType,
  PatientEhrType,
  PatientInfoType,
  PatientInitialStateType,
  PatientOrgInfoType,
} from "DataTypes/Redux";
import {
  ADD_PATIENT_INFO,
  ADD_PATIENT_ORG_INFO,
  ADD_SELECTED_PRGM_INFO,
  CLEAR_PATIENT,
  CLEAR_PATIENT_INFO,
  CLEAR_PATIENT_ORG_INFO,
  CLEAR_SELECTED_PRGM_INFO,
  ADD_SELECTED_TRAINING_INFO,
  CLEAR_SELECTED_TRAINING_INFO,
  ADD_SELECTED_DEVICE_INFO,
  CLEAR_SELECTED_DEVICE_INFO,
  ADD_RPM_PRGM_INFO,
  CLEAR_RPM_PRGM_INFO,
  ADD_PRGM_ARR,
  CLEAR_PRGM_ARR,
  SET_PATIENT_EHR,
  SET_PATIENT_EHR_ACTIVE_SYNC,
  SET_PATIENT_EHR_SYNC_SIGNAL,
  CLEAR_PATIENT_EHR,
  SET_PATIENT_CLINICAL_COUNTS,
  CLEAR_PATIENT_CLINICAL_COUNTS,
} from "./type";
import { FormatEligiblePrgmType } from "DataTypes/PatientManagement.type";
import {
  PatientDeviceDetails,
  PatientDeviceTrainingType,
} from "DataTypes/Services/Patient.type";

export const PatientInfoInitialState: PatientInfoType = {
  address2: "",
  age: "",
  city: "",
  country: "",
  dob: "",
  ehrPatientId: "",
  lastEhrVisitDate: "",
  email: "",
  firstName: "",
  gender: "",
  home: "",
  id: null,
  language: "",
  lastName: "",
  middleName: "",
  mobile: "",
  name: "",
  sex: "",
  state: "",
  streetAddress: "",
  zip: "",
  notes: "",
  firstTimeNotesVisit: false,
};

export const PatientOrgInfoInitialState: PatientOrgInfoType = {
  practiceId: null,
  practiceName: "",
  practiceLocationId: null,
  practiceLocationName: "",
  practiceLocationTimezone: "",
};

export const selectedPrgmInitialState: FormatEligiblePrgmType = {
  abbrevation: "",
  activity: "",
  appointment_date: "",
  appointment_id: null,
  billableproviderId: null,
  carecoordinators: [],
  caremanagerId: null,
  careplanActivity: null,
  careplanCreatedInEhr: "",
  careplanFrequency: "",
  careplanId: null,
  careplanInitDateInEhr: "",
  careplanRecurringId: null,
  careplanRecurringStatus: "",
  careplanState: "",
  careplanStage: 0,
  consentGainedBy: null,
  dischargeDate: "",
  eligibleForEnroll: false,
  eligibleProgramId: null,
  enrollmentId: null,
  isCareplanComprehensive: false,
  hasCareplanQuestionnaireCompleted: false,
  nextSchedule: "",
  patientDevices: [],
  patientId: null,
  planningMonth: null,
  planningYear: null,
  practiceId: null,
  practiceLocationId: null,
  practiceLocationName: "",
  practiceLocationTimezone: "",
  practiceName: "",
  programId: null,
  providerId: null,
  providerName: "",
  status: null,
  seniorTeamMember: false,
  teamInitiatorRoleId: null,
  teamInitiatedBy: null,
  teamMember: false,

  showLogTime: false,
  enrollmentDate: "",
  recurringPlanningMonth: null,
  recurringPlanningYear: null,
  readOnlyArr: [],
  callDefaultRoute: "",
  showSaveBtn: false,
  showSubmitBtn: false,
  careplanType: "",
};

export const selectedTrainingInitialState: PatientDeviceTrainingType = {
  id: null,
  trainerId: null,
  trainerName: "",
  trainingActivity: "",
  trainingCreatedById: null,
  trainingCreatedBy: "",
  trainingId: null,
  trainingRequired: false,
  trainingStatusDescription: "",
  trainingStatusId: "",
  trainingTypeDescription: "",
  trainingTypeId: "",
};

export const selectedDeviceInitialState: PatientDeviceDetails = {
  actualDeviceId: "",
  deviceId: null,
  deviceName: "",
  deviceProvider: "",
  deviceProviderValue: "",
  deviceTypeDescription: "",
  deviceTypeId: null,
  fromDate: "",
  id: null,
  isDeleted: false,
  isDeviceSuspended: false,
  patientDeviceId: null,
  supplierName: null,
  thruDate: "",
};

export const PatientEhrInitialState: PatientEhrType = {
  vendor: null,
  enabled: false,
  syncDomains: [],
  activeSyncDomain: null,
  syncSignal: null,
};

const INITIAL_STATE: PatientInitialStateType = {
  patientInfo: PatientInfoInitialState,
  eligiblePrgmArr: [],
  selectedPrgm: selectedPrgmInitialState,
  rpmPrgm: selectedPrgmInitialState,
  patientOrg: PatientOrgInfoInitialState,
  selectedTraining: selectedTrainingInitialState,
  selectedDevice: selectedDeviceInitialState,
  ehr: PatientEhrInitialState,
  clinicalCounts: null,
};

const reducer = (state = INITIAL_STATE, action: PatientActionReturnType) => {
  switch (action.type) {
    case ADD_PATIENT_INFO:
      return {
        ...state,
        patientInfo: action.payload,
      };
    case CLEAR_PATIENT_INFO:
      return {
        ...state,
        patientInfo: INITIAL_STATE.patientInfo,
      };
    case ADD_PRGM_ARR:
      return {
        ...state,
        eligiblePrgmArr: action.payload,
      };
    case CLEAR_PRGM_ARR:
      return {
        ...state,
        eligiblePrgmArr: INITIAL_STATE.eligiblePrgmArr,
      };
    case ADD_PATIENT_ORG_INFO:
      return {
        ...state,
        patientOrg: action.payload,
      };
    case CLEAR_PATIENT_ORG_INFO:
      return {
        ...state,
        patientOrg: INITIAL_STATE.patientOrg,
      };
    case ADD_SELECTED_PRGM_INFO:
      return {
        ...state,
        selectedPrgm: action.payload,
      };
    case CLEAR_SELECTED_PRGM_INFO:
      return {
        ...state,
        selectedPrgm: INITIAL_STATE.selectedPrgm,
      };
    case ADD_RPM_PRGM_INFO:
      return {
        ...state,
        rpmPrgm: action.payload,
      };
    case CLEAR_RPM_PRGM_INFO:
      return {
        ...state,
        rpmPrgm: INITIAL_STATE.rpmPrgm,
      };
    case ADD_SELECTED_TRAINING_INFO:
      return {
        ...state,
        selectedTraining: action.payload,
      };
    case CLEAR_SELECTED_TRAINING_INFO:
      return {
        ...state,
        selectedTraining: INITIAL_STATE.selectedTraining,
      };
    case ADD_SELECTED_DEVICE_INFO:
      return {
        ...state,
        selectedDevice: action.payload,
      };
    case CLEAR_SELECTED_DEVICE_INFO:
      return {
        ...state,
        selectedDevice: INITIAL_STATE.selectedDevice,
      };
    // Merged rather than replaced, so storing capabilities cannot clobber an
    // activeSyncDomain set moments earlier by a click.
    case SET_PATIENT_EHR:
      return {
        ...state,
        ehr: { ...state.ehr, ...(action.payload as Partial<PatientEhrType>) },
      };
    case SET_PATIENT_EHR_ACTIVE_SYNC:
      return {
        ...state,
        ehr: {
          ...state.ehr,
          activeSyncDomain: action.payload as string | null,
        },
      };
    // Pins a new "domain X just synced" note for on-screen sections to react
    // to. The count only has to change; its value carries no meaning.
    case SET_PATIENT_EHR_SYNC_SIGNAL:
      return {
        ...state,
        ehr: {
          ...state.ehr,
          syncSignal: {
            domain: action.payload as string,
            count: (state.ehr.syncSignal?.count || 0) + 1,
          },
        },
      };
    case CLEAR_PATIENT_EHR:
      return {
        ...state,
        ehr: INITIAL_STATE.ehr,
      };
    case SET_PATIENT_CLINICAL_COUNTS:
      return {
        ...state,
        clinicalCounts: action.payload,
      };
    case CLEAR_PATIENT_CLINICAL_COUNTS:
      return {
        ...state,
        clinicalCounts: INITIAL_STATE.clinicalCounts,
      };
    case CLEAR_PATIENT:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export default reducer;
